const axios = require('axios')

export default {
  methods: {
    getBlobByUrl (url) {
      const instCred = axios.create({
        baseURL: url,
        responseType: 'blob'
      })
      return instCred.get()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getBlobByUrl.js